'use client';

interface ShareIconProps {
  size?: number;
  background?: string;
  foreground?: string;
}

const LegacyShareIcon = ({ size = 40, background = '#F0F0F0', foreground = '#686868' }: ShareIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill={background} />
      <path
        d="M16.3951 21.1325L21.6125 24.1175M21.6049 15.8825L16.3951 18.8675M25.875 14.75C25.875 15.9926 24.849 17 23.5833 17C22.3177 17 21.2917 15.9926 21.2917 14.75C21.2917 13.5074 22.3177 12.5 23.5833 12.5C24.849 12.5 25.875 13.5074 25.875 14.75ZM16.7083 20C16.7083 21.2426 15.6823 22.25 14.4167 22.25C13.151 22.25 12.125 21.2426 12.125 20C12.125 18.7574 13.151 17.75 14.4167 17.75C15.6823 17.75 16.7083 18.7574 16.7083 20ZM25.875 25.25C25.875 26.4926 24.849 27.5 23.5833 27.5C22.3177 27.5 21.2917 26.4926 21.2917 25.25C21.2917 24.0074 22.3177 23 23.5833 23C24.849 23 25.875 24.0074 25.875 25.25Z"
        stroke={foreground}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3951 21.1325L21.6125 24.1175M21.6049 15.8825L16.3951 18.8675M25.875 14.75C25.875 15.9926 24.849 17 23.5833 17C22.3177 17 21.2917 15.9926 21.2917 14.75C21.2917 13.5074 22.3177 12.5 23.5833 12.5C24.849 12.5 25.875 13.5074 25.875 14.75ZM16.7083 20C16.7083 21.2426 15.6823 22.25 14.4167 22.25C13.151 22.25 12.125 21.2426 12.125 20C12.125 18.7574 13.151 17.75 14.4167 17.75C15.6823 17.75 16.7083 18.7574 16.7083 20ZM25.875 25.25C25.875 26.4926 24.849 27.5 23.5833 27.5C22.3177 27.5 21.2917 26.4926 21.2917 25.25C21.2917 24.0074 22.3177 23 23.5833 23C24.849 23 25.875 24.0074 25.875 25.25Z"
        stroke={foreground}
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LegacyShareIcon;
